import S25FLaunchCountdown from '../S25FLaunchCountdown';
import '../../styles/donate.css';

/**
 * The `ApplyGate` registered section type (see tenant_site/section_types.py,
 * tenant_site/system_pages.py's ApplyPage) — the locked, non-deletable
 * second section on the Apply System Page. No admin-editable `data`: this is
 * a placeholder for scholarship applications. There is no intake model or
 * form yet (see docs/plans/applications.md — an L-sized build), so this is
 * countdown-only, gated on the same Section 25F date as Donate, since a
 * scholarship application has nothing to fund before the credit exists.
 * Swap the post-launch branch for the real intake form once
 * applications.md ships.
 */
export default function ApplyGateSection() {
  return (
    <section className="section donate">
      <div className="wrap donate-wrap">
        <S25FLaunchCountdown
          title="Applications open January 1, 2027"
          description="Scholarships are funded by Section 25F gifts, so applications open alongside the credit itself, starting tax year 2027. Check back then."
        >
          <div className="head">
            <div className="eyebrow">Scholarships</div>
            <h2>Apply for a <em>scholarship</em></h2>
          </div>
          <p data-testid="apply-not-open">
            Applications aren't open yet. Check back once Section 25F scholarships begin.
          </p>
        </S25FLaunchCountdown>
      </div>
    </section>
  );
}
